// extracted by mini-css-extract-plugin
module.exports = {"R3Page":"NewProductContent_R3Page__qH_t0"};